.ao{flex:1;}